module.exports = __webpack_public_path__ + "media/images/instagram-Icon-5e5f30d4ab03177239ad8bef2ba6452c.png";